import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollDetailSchema } from './shapes';

export const closePoll = defineEndpoint({
  method: 'POST',
  path: '/v1/polls/:pollId/close',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: PollDetailSchema }),
});
